import Api from "@/services/api.service";

export default {
  getList(filter) {
    return Api().get("product/public/get", { params: filter });
  },
  getManufacturList(filter) {
    return Api().get("manufacturer/public/get", { params: filter });
  },
  getManufacturNameList() {
    return Api().get("manufacturer/name");
  },
  get(id) {
    return Api().get("product/public/get/" + id);
  },
  submitDeclaration(data) {
    return Api().post("product/declarationForm/create", data);
  },
  generateDeclationPdf(id) {
    return Api().get("product/declarationPdf/" + id, { responseType: "blob" });
  }
};
